export default __webpack_public_path__ + "static/media/cedrus_rb04pro.4d9f78cb.jpg";